import { Locale } from '@empiriecom/module-components/IntlProvider';
import { LocalizedPath } from '@empiriecom/mybuy-components/interfaces/types';

const getLocalizedPath = (pathConfig: LocalizedPath, locale: string) =>
  pathConfig[locale as Locale] ?? pathConfig.default;

export default getLocalizedPath;
